import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Badge } from "@/components/ui/badge";
import { Building2 } from "lucide-react";

export default function Vendors() {
  const [rows, setRows] = useState([]);
  useEffect(() => { api.get("/vendors").then((r) => setRows(r.data)); }, []);
  return (
    <div className="space-y-6">
      <div>
        <div className="text-xs uppercase tracking-[0.25em] text-muted-foreground mb-1">Vendor Network</div>
        <h1 className="font-display text-3xl font-bold tracking-tight">Partner vendors</h1>
      </div>
      <Card className="border-border shadow-none overflow-hidden">
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>Vendor</TableHead>
              <TableHead>Type</TableHead>
              <TableHead>Region</TableHead>
              <TableHead>SLA</TableHead>
              <TableHead className="text-right">Spend YTD</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {rows.map((v) => (
              <TableRow key={v.id}>
                <TableCell>
                  <div className="flex items-center gap-2">
                    <div className="h-8 w-8 rounded-md bg-[#0047AB]/10 text-[#0047AB] grid place-items-center"><Building2 className="h-4 w-4" /></div>
                    <span className="font-medium">{v.name}</span>
                  </div>
                </TableCell>
                <TableCell><Badge variant="outline" className="text-[10px] font-mono uppercase tracking-wider">{v.type}</Badge></TableCell>
                <TableCell className="text-sm">{v.region}</TableCell>
                <TableCell className="font-mono text-sm">{v.sla}</TableCell>
                <TableCell className="text-right font-mono">${v.spend_ytd.toLocaleString()}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </Card>
    </div>
  );
}
